import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";

import { AgGridVue } from 'ag-grid-vue3';
import WsGrid from '@/components/work-sched/ws-grid.vue';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";

import VueFeather from 'vue-feather';

import '@/assets/scss/config/saas/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';

//import '@/helpers/ag-grid-enterprise';
import '@/helpers/ag-grid-enterprise/styles/ag-grid.css';
import '@/helpers/ag-grid-enterprise/styles/ag-theme-alpine.css';
import '@/assets/css/ag-grid-overrides.css';

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

window.addEventListener('error', (e) => {
    if (
        e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded'
    ) {
        e.stopImmediatePropagation();
    }
});

createApp(App)
    .use(store)
    .use(router)
    .component('AgGridVue', AgGridVue)
    .component('WsGrid', WsGrid)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(VueSweetalert2)
    .use(vClickOutside)
    .mount('#app');
